module.exports = __webpack_public_path__ + "img/swish.4a5d18ac.png";